var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50201 3.66656V3.22211C8.50201 2.59983 8.50201 2.28869 8.3809 2.05101C8.27438 1.84194 8.1044 1.67197 7.89533 1.56544C7.65765 1.44434 7.34651 1.44434 6.72423 1.44434H5.83534C5.21306 1.44434 4.90192 1.44434 4.66424 1.56544C4.45517 1.67197 4.28519 1.84194 4.17867 2.05101C4.05756 2.28869 4.05756 2.59983 4.05756 3.22211V3.66656M5.16867 6.72211V9.49989M7.3909 6.72211V9.49989M1.27979 3.66656H11.2798M10.1687 3.66656V9.88878C10.1687 10.8222 10.1687 11.2889 9.98702 11.6454C9.82723 11.959 9.57226 12.214 9.25866 12.3738C8.90214 12.5554 8.43543 12.5554 7.50201 12.5554H5.05756C4.12414 12.5554 3.65743 12.5554 3.30091 12.3738C2.98731 12.214 2.73234 11.959 2.57255 11.6454C2.3909 11.2889 2.3909 10.8222 2.3909 9.88878V3.66656",
    stroke: "#D32728",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteIcon.2b9893182bb6732a670e730daf9c0201.svg";